<script setup>
import CardLayout from 'dashboard/components-next/CardLayout.vue';

defineProps({
  name: {
    type: String,
    required: true,
  },
  countLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['open']);
</script>

<template>
  <CardLayout class="cursor-pointer" @click="emit('open')">
    <div class="flex items-center justify-between w-full gap-3">
      <span class="text-base font-medium text-n-slate-12 line-clamp-1">
        {{ name }}
      </span>
      <span class="text-sm text-n-slate-11 shrink-0">
        {{ countLabel }}
      </span>
    </div>
  </CardLayout>
</template>
